export let ScrollAreaScrollbarDataAttributes = /*#__PURE__*/function (ScrollAreaScrollbarDataAttributes) {
  /**
   * Indicates the orientation of the scrollbar.
   * @type {'horizontal' | 'vertical'}
   */
  ScrollAreaScrollbarDataAttributes["orientation"] = "data-orientation";
  /**
   * Present when the pointer is over the scroll area.
   */
  ScrollAreaScrollbarDataAttributes["hovering"] = "data-hovering";
  /**
   * Present when the user scrolls inside the scroll area.
   */
  ScrollAreaScrollbarDataAttributes["scrolling"] = "data-scrolling";
  /**
   * Present when the scroll area content is wider than the viewport.
   */
  ScrollAreaScrollbarDataAttributes["hasOverflowX"] = "data-has-overflow-x";
  /**
   * Present when the scroll area content is taller than the viewport.
   */
  ScrollAreaScrollbarDataAttributes["hasOverflowY"] = "data-has-overflow-y";
  /**
   * Present when there is overflow on the horizontal start side.
   */
  ScrollAreaScrollbarDataAttributes["overflowXStart"] = "data-overflow-x-start";
  /**
   * Present when there is overflow on the horizontal end side.
   */
  ScrollAreaScrollbarDataAttributes["overflowXEnd"] = "data-overflow-x-end";
  /**
   * Present when there is overflow on the vertical start side.
   */
  ScrollAreaScrollbarDataAttributes["overflowYStart"] = "data-overflow-y-start";
  /**
   * Present when there is overflow on the vertical end side.
   */
  ScrollAreaScrollbarDataAttributes["overflowYEnd"] = "data-overflow-y-end";
  return ScrollAreaScrollbarDataAttributes;
}({});